(function () {
  // Hide shipping/tax line on this product
  var shippingEl = document.querySelector('.product__tax');
  if (shippingEl) shippingEl.style.display = 'none';

  var waitForForm = function (callback) {
    var existing = document.querySelector('#globo-formbuilder-50018');
    if (existing) { callback(existing); return; }

    var observer = new MutationObserver(function () {
      var el = document.querySelector('#globo-formbuilder-50018');
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  waitForForm(function (formEl) {
    formEl.style.display = 'none';

    // Reveal immediately if a camera model is already selected on page load
    // (e.g. user arrived via a ?variant= URL)
    var urlParams = new URLSearchParams(window.location.search);
    var hasVariantInUrl = urlParams.has('variant');
    var cameraAlreadyChecked = Array.from(
      document.querySelectorAll('input[type="radio"]')
    ).some(function (r) {
      return r.name.indexOf('Ferret Camera Model') !== -1 && r.checked;
    });

    if (hasVariantInUrl || cameraAlreadyChecked) {
      showForm();
    }

    function clonePrice() {
      var source = document.querySelector('[id^="price-"]');
      var dest = document.querySelector('#warranty-price-clone');
      if (source && dest) dest.innerHTML = source.innerHTML;
    }

    subscribe('variant-change', function () { setTimeout(clonePrice, 50); });

    subscribe('variant-change', function () {
      var cameraSelected = Array.from(
        document.querySelectorAll('input[type="radio"]')
      ).some(function (r) { return r.name.indexOf('Ferret Camera Model') !== -1 && r.checked; });

      if (cameraSelected && formEl.style.display === 'none') {
        showForm();
      }
    });

    function showForm() {
      formEl.style.display = 'block';
      var repeatPrice = document.querySelector('#warranty-price-repeat');
      if (repeatPrice) repeatPrice.style.display = 'block';
      clonePrice();
      var variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        var top = variantSelects.getBoundingClientRect().top + window.scrollY - 95;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (input.type !== 'radio') return;
      if ((input.name || '').indexOf('Ferret Camera Model') !== -1) {
        showForm();
      }
    });

    var cartForm = document.querySelector('form[action="/cart/add"]');

    var fired = false;
    var pollInterval = null;

    function isSuccessVisible() {
      var el = document.querySelector('.globo-form-app > .message.success');
      return el && el.offsetHeight > 0 && getComputedStyle(el).display !== 'none';
    }

    var successObserverConfig = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    };

    function startPollInterval() {
      if (pollInterval) return;
      pollInterval = setInterval(function () {
        if (fired) { clearInterval(pollInterval); pollInterval = null; return; }
        if (isSuccessVisible()) { handleConfirmation(); }
      }, 300);
    }

    // Start polling only when the user clicks submit — not on page load
    formEl.addEventListener('click', function (e) {
      if (e.target.closest('.wizard__submit')) {
        startPollInterval();
      }
    });

    function handleConfirmation() {
      if (fired) return;
      fired = true;
      clearInterval(pollInterval);
      pollInterval = null;
      successObserver.disconnect();

      var variantInput = cartForm ? cartForm.querySelector('input[name="id"]') : null;
      var variantId = variantInput && variantInput.value;

      if (!variantId) {
        showError('Could not determine the selected variant. Please refresh and try again.');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw data; });
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          fired = false;
          pollInterval = null;
          startPollInterval();
          successObserver.observe(document.body, successObserverConfig);
          var msg =
            (err && (err.description || err.message)) ||
            'This item could not be added to your cart. Please try again.';
          showError(msg);
        });
    }

    var successObserver = new MutationObserver(function () {
      if (!fired && isSuccessVisible()) { handleConfirmation(); }
    });

    successObserver.observe(document.body, successObserverConfig);

    function showError(msg) {
      var el = document.getElementById('warranty-cart-error');
      if (!el) {
        el = document.createElement('p');
        el.id = 'warranty-cart-error';
        el.style.cssText =
          'color:#b00020;margin-top:1em;font-size:0.875rem;font-weight:600;';
        formEl.insertAdjacentElement('afterend', el);
      }
      el.textContent = msg;
    }
  });
})();
